import React from "react";
import {Box, IconButton, TextField} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

const SearchField = ({
                         label,
                         value,
                         onChange,
                         onKeyDown,
                         placeholder,
                         isSmall,
                     }) => {
    return (
        <Box sx={{position: "relative", width: isSmall ? "100%" : 220}}>
            <TextField
                size="small"
                variant="outlined"
                value={value}
                onChange={onChange}
                onKeyDown={onKeyDown}
                label={
                    <Box sx={{display: "flex", alignItems: "center", gap: 0.6}}>
                        <SearchIcon fontSize="small" sx={{mb: 0.4}}/>
                        {placeholder || label}
                    </Box>
                }
                fullWidth
                sx={{
                    "& .MuiOutlinedInput-root": {
                        pr: "32px !important",
                        transition: "none",
                    },
                }}
            />


            {value && (
                <IconButton
                    size="small"
                    disableRipple
                    disableFocusRipple
                    onClick={() => onChange({target: {value: ""}})}
                    sx={{
                        position: "absolute",
                        right: 4,
                        top: "50%",
                        transform: "translateY(-50%)",
                        p: 0.3,
                        color: "action.active",
                        "&:hover": {background: "transparent"},
                    }}
                >
                    <ClearIcon fontSize="small"/>
                </IconButton>
            )}
        </Box>
    );
};

export default SearchField;
